import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Stack, Tooltip, Typography } from '@mui/material';
import React from 'react';

function FieldLabel({ label, tooltip }) {
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Typography sx={{ flexShrink: 1 }}>{label}</Typography>
      {!!tooltip && (
        <Tooltip title={tooltip} arrow>
          <Typography
            component="span"
            sx={{ color: 'text.secondary', lineHeight: 1, ml: 'auto' }}
          >
            <FontAwesomeIcon icon="fa-circle-info" />
          </Typography>
        </Tooltip>
      )}
    </Stack>
  );
}

export default FieldLabel;
